import { IElement } from 'bom/types';
import { IJobPart } from 'jobs/types';

export const mapOnCellValueChanged = (
  data: { [key: string]: unknown },
  jobId: number,
  jobPart: IJobPart,
  element?: IElement
) => {
  let quantityData = {};
  if (data.quantity) {
    quantityData = {
      updateElements: [
        {
          id: element?.id || jobPart.elements?.[0].id,
          quantity: data.quantity,
        },
      ],
    };

    delete data.quantity;
  }

  return {
    bomPart: {
      bomId: jobId,
      ...(jobPart.partArr?.id && { partId: jobPart.partArr.id }),
      ...(jobPart.bomPartId && { bomPartId: jobPart.bomPartId }),
      ...(jobPart.componentId && { componentId: jobPart.componentId }),
      ...(!!element?.id && { elementId: element.id }),
      ...data,
      ...quantityData,
    },
  };
};
